module.exports = __webpack_public_path__ + "img/ca.6fade150.jpg";